import { RootState } from '.';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Report } from '../types/Reports';

export interface ReportsState {
  reportsList: Report[];
  isLoading: boolean;
  isAllowedToActivateReporting: boolean;
}

const initialState: ReportsState = {
  reportsList: [],
  isLoading: true,
  isAllowedToActivateReporting: false,
};

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setReportsList: (state, action: PayloadAction<{ reports: Report[] }>) => {
      state.isLoading = false;
      state.reportsList = action.payload.reports;
    },
    updateReport: (state, action: PayloadAction<{ newReport: Report }>) => {
      const { newReport } = action.payload;
      state.reportsList = state.reportsList.map((report) =>
        report.id === newReport.id ? { ...report, ...newReport } : report,
      );
    },
    setIsAllowedToActivateReporting: (state, action: PayloadAction<boolean>) => {
      state.isAllowedToActivateReporting = action.payload;
    },
  },
});

export const selectReports = (state: RootState) => state.reports.reportsList;
export const isReportsLoading = (state: RootState) => state.reports.isLoading;
export const isAllowedToActivateReporting = (state: RootState) =>
  state.reports.isAllowedToActivateReporting;

export const { setReportsList, updateReport, setIsAllowedToActivateReporting } =
  reportsSlice.actions;
export default reportsSlice.reducer;
